import {
    Icon,
    Input,
    Button,
    Flex,
    useDisclosure,
    Box,
    useColorModeValue,
    Spacer,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Grid,
    Text,
    Select
} from '@chakra-ui/react'
import React, {useEffect, useState} from "react";
import {useAuthHeader} from "react-auth-kit";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import {VscDiffAdded} from "react-icons/vsc";
import {RiDeleteBin6Line} from "react-icons/ri";

export default function LimitEdit(getAction) {
    const textColor = useColorModeValue("gray.200", "white");
    const textColorTitle = useColorModeValue("gray.600", "white");
    const token = useAuthHeader();
    const [limitResponse, setLimitResponse] = useState('')
    const [showError, setShowError] = useState(null)
    const [action, setAction] = useState(false)
    const [result, setResult] = useState([])
    const { id } = useParams();
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure()


    const [serviceList, setServiceList] = useState([{ service: "", param: "" }]);

    const handleServiceChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...serviceList];
        list[index][name] = value;
        setServiceList(list);
    };

    const handleServiceRemove = (index) => {
        const list = [...serviceList];
        list.splice(index, 1);
        setServiceList(list);
    };

    const handleServiceAdd = () => {
        setServiceList([...serviceList, { service: "", param: "" }]);
    };


    const toggle = () => {
        onClose()
        navigate(`/admin_area/limits`);
    }

    const toggleShow = () => {
        setShowError(true)
    }

    useEffect(() => {
        setAction(getAction)
    },[getAction])

    useEffect(() => {
        if (action){
            let active = true
            const getResult = async () => {
                if (active) {
                    const result = await fetchData(id, token());
                    setResult(result)
                    return () => {
                        active = false;
                    };
                }
            }

            getResult().then();
            return () => {
                active = false;
            };
        }
    },[action])


    async function onSubmitBox() {
        try {

            const newData = await editLimit(id, serviceList, token());
            setLimitResponse(newData)
            onOpen()
        } catch (e) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    alert(JSON.stringify(e.response.data, null, 2))
                    resolve()
                }, 1000)
            })
        }
    }

    return (

        <Flex direction='column' pt={{ base: "150px", md: "75px" }}>


            <Box p='6px 0px 22px 0px'>
                <Text fontSize='xl' color={textColorTitle} fontWeight='bold'>
                    Редактирование лимита
                </Text>
            </Box>

            <Grid
                minChildWidth="250px"
                templateColumns={{ sm: "1fr", md: "1fr", lg: "1fr" }}
                templateRows={{ sm: "1fr auto", md: "1fr", lg: "1fr" }}
                gap='24px'
            >

                <Box w='100%' mb='20px'>
                    <Flex maxW='500px'>
                        <Button colorScheme='teal' onClick={() => {navigate(`/admin_area/limits`)}}>
                            Назад
                        </Button>
                    </Flex>
                </Box>

                <Grid ml="100px">
                    <pre>{JSON.stringify(result, null, 2)}</pre>
                </Grid>

                <Grid>
                    <form autoComplete="off">
                        <Box
                            border='1px'
                            borderRadius='5px'
                            borderColor={textColor}
                            maxW='100%'
                            w='100%'
                            p={4}
                        >

                            {serviceList.map((singleService, index) => (
                                <Flex key={index} minWidth='max-content' alignItems='center' gap='2'>
                                    <lable>Значение</lable>
                                    <Box
                                        maxW='500px'
                                        w='100%'
                                        p='2'>
                                        <Select placeholder={' '}
                                                name="service"
                                                id="service"
                                                value={singleService.service}
                                                onChange={(e) => handleServiceChange(e, index)}
                                                required
                                        >
                                            <option value='limit'>limit</option>
                                            <option value='error_description'>error_description</option>
                                        </Select>
                                    </Box>
                                    <Spacer/>
                                    <lable>Параметр</lable>
                                    <Box maxW='500px'
                                         w='100%'
                                         p='2'>

                                        <Input
                                            name="param"
                                            id="param"
                                            value={singleService.param}
                                            onChange={(e) => handleServiceChange(e, index)}
                                            required
                                        />
                                    </Box>

                                    <Box p='2'>
                                        {serviceList.length !== 1 && (
                                            <Icon as={RiDeleteBin6Line} color="red" cursor="pointer" onClick={() => handleServiceRemove(index)}/>
                                        )}
                                        <Spacer/>
                                        {serviceList.length - 1 === index && serviceList.length < 2 && (
                                            <Icon as={VscDiffAdded} color="blue" cursor="pointer" onClick={handleServiceAdd}/>
                                        )}
                                    </Box>

                                </Flex>
                            ))}


                            <Button mt={4} colorScheme='teal' onClick={onSubmitBox}>
                                Отправить
                            </Button>

                        </Box>

                        <Grid>

                            <br></br>
                            <Grid ml="100px">
                                <h2>Какой параметр будет изменен :</h2>
                                <br></br>
                                {serviceList &&
                                serviceList.map((singleService, index) => (
                                    <ul key={index}>
                                        {singleService.service &&
                                        <li>
                                            {singleService.service}
                                        </li>}
                                        {singleService.param &&
                                        <p>{singleService.param}</p>}
                                    </ul>
                                ))}
                            </Grid>
                        </Grid>

                    </form>
                </Grid>
            </Grid>

            <Grid>
                <Modal isOpen={isOpen} size={'xl'} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Редактирование лимита</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            {limitResponse.info
                                ? limitResponse.info
                                : <pre style={{fontSize: '15px'}}>{JSON.stringify(limitResponse, null, 2)}</pre>
                            }
                            <br/>
                            <br/>
                            {showError
                                ? <pre-wrap>{JSON.stringify(limitResponse.error, null, 2)}</pre-wrap>
                                : ''
                            }
                        </ModalBody>
                        <ModalFooter>
                            {limitResponse.error
                                ? <Button colorScheme='red' onClick={toggleShow}>Подробности</Button>
                                : ''
                            }
                            <Spacer/>
                            <Button colorScheme='blue' onClick={toggle}>Закрыть</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </Grid>

        </Flex>
    )
}


async function editLimit(id, params, token) {
    try {
        let d = []
        let am = []

        params.forEach(id => {
            d.push(id.service)
            am.push(id.param)
        })

        let result = {};
        result['id'] = id
        for (let i = 0; i < d.length; ++i)
        {
            result[d[i]] = am[i]
        }
        const response = await axios.put(`/api/v1/limits/templates/${id}`, result,
            {headers: {Authorization: token}})
        return await response.data
    } catch (e) {
        if (e.response) {
            let error = {}
            error['info'] = "Невозможно редактировать лимит"
            if ( Object.assign(e.response.data).errors ) {
                error['error'] = Object.assign(e.response.data).errors
            } else {
                error['error'] = e.response.data
            }

            return error
        }
    }
}

async function fetchData(id = 1, token) {
    const response = await axios.get(`/api/v1/limits/templates/${id}`,
        {headers: {Authorization: token}})
    return await response.data;
}
